"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ListComponent_form_1 = __importDefault(require("../_classes/list/ListComponent.form"));
const Radio_edit_data_1 = __importDefault(require("./editForm/Radio.edit.data"));
const Radio_edit_display_1 = __importDefault(require("./editForm/Radio.edit.display"));
const Radio_edit_validation_1 = __importDefault(require("./editForm/Radio.edit.validation"));
const AriForm_1 = require("../../AriForm");
/**
 * The Edit Form function.
 * @param {...any} extend - The components that extend the edit form.
 * @returns {import('@ariform/core').Component[]} - The edit form components.
 */
function default_1(...extend) {
    return (0, ListComponent_form_1.default)([
        {
            key: 'display',
            components: Radio_edit_display_1.default
        },
        {
            key: 'data',
            components: Radio_edit_data_1.default
        },
        {
            key: 'validation',
            components: Radio_edit_validation_1.default
        },
        {
            key: 'api',
            components: [
                {
                    key: 'tags',
                    ignore: AriForm_1.AriForm.isBPM
                },
                {
                    key: 'properties',
                    ignore: AriForm_1.AriForm.isBPM
                }
            ]
        },
        {
            key: 'logic',
            ignore: AriForm_1.AriForm.isBPM,
        },
        {
            key: 'layout',
            ignore: AriForm_1.AriForm.isBPM,
        },
        {
            key: 'addons',
            ignore: AriForm_1.AriForm.isBPM,
        },
        {
            key: 'autofocus',
            ignore: AriForm_1.AriForm.isBPM,
        },
    ], ...extend);
}
exports.default = default_1;
